import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "documentCount",
})
export class DocumentCountPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) {
      return 0;
    } else {
      try {
        let count = JSON.parse(value).length;
        return count;
      } catch (error) {
        return 0;
      }
    }
  }
}
